module.exports = __webpack_public_path__ + "static/img/industrial2.a10d2d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/industrial/industrial2.png
// module id = BBFJ
// module chunks = 11